import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';
import { formatDate } from '../../../../utilities';

interface INoLessonsInPeriodDialogProps {
  beginAt: Date | string;
  endAt: Date | string;
  isLoading: boolean;
  onConfirmClick: () => void;
  onCancelClick: () => void;
}

export function NoLessonsInPeriodDialog({ beginAt, endAt, isLoading, onConfirmClick, onCancelClick }: INoLessonsInPeriodDialogProps) {
  return (
    <ConfirmDialog
      title="Ingen lektioner i periode, fortsæt?"
      type="question"
      open
      onConfirmClick={onConfirmClick}
      onCancelClick={onCancelClick}
      confirmButtonText="Ja, fortsæt"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isLoading}
    >
      <p>{`Der er i perioden ${formatDate(beginAt)} - ${formatDate(endAt)} ingen lektioner`}</p>
    </ConfirmDialog>
  );
}
